import React, { useState, useEffect } from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap';

interface Post {
  id: number;
  title: string;
  summary: string;
  date: string;
}

const PostList: React.FC = () => {
  const [posts, setPosts] = useState<Post[]>([]);

  useEffect(() => {
    // Replace with API call or mock data
    setPosts([
      { id: 1, title: 'First Post', summary: 'This is the first blog post.', date: '2025-02-17' },
      { id: 2, title: 'Second Post', summary: 'This is the second blog post.', date: '2025-02-16' },
    ]);
  }, []);

  return (
    <Row>
      {posts.map((post) => (
        <Col key={post.id} sm={12} md={6} lg={4}>
          <Card className="mb-4">
            <Card.Body>
              <Card.Title>{post.title}</Card.Title>
              <Card.Text>{post.summary}</Card.Text>
              <Button variant="primary" href={`/post/${post.id}`}>
                Read More
              </Button>
            </Card.Body>
            <Card.Footer className="text-muted">{post.date}</Card.Footer>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default PostList;
